import OkTableConfigType from '@/@bya3/components/tables/ok-table/OkTableConfigType'
import { API_URL } from '@/constants/config'
import CommonTableActions from '@/constants/common-table-actions'

const ReplyTemplateTableConfig: OkTableConfigType = {
  mode: 'remote',
  url: `${API_URL}/facebook/reply/templates`,
  rowsPath: 'templates',
  rowClickable: true,
  attachPageId: false,
  columns: [
    {
      label: 'reply.template_name',
      field: 'name',
    },
    {
      label: 'reply.message_type',
      field: 'message_type',
    },
    {
      label: 'reply.reply-type',
      field: 'reply_type',
    },
  ],
  paginationOptions: {
    enabled: true,
  },
  sortOptions: {
    enabled: false,
  },
  actions: [
    ...CommonTableActions,
  ],
  filters: [
  ],
}

export default ReplyTemplateTableConfig
